import { AbstractComponent } from '@/utils/sections/abstract-component';
import { register } from '@/utils/sections/registration';
import tippy, { followCursor } from 'tippy.js';

const scales = {
  'top-center': 1.5,
  right: 1.2,
  'left-center': 1.3,
  left: 1.6,
  'bottom-center': 1.7,
  'right-center': 2,
  bottom: 1.5,
};

export class CommercialBay extends AbstractComponent {
  init() {
    const { el } = this;
    const svg = el.querySelector('svg');
    const groups = svg.querySelectorAll('#items > g');
    const map = el.querySelector('[data-map]');
    const canvas = el.querySelector('[data-canvas]');
    const popupWidth = el.querySelector('div[data-popup]').getBoundingClientRect().width;
    const svgRect = svg.getBoundingClientRect();
    const ctas = el.querySelectorAll('button[data-popup]');
    const closeModalButton = el.querySelector('[data-popup-close]');
    const closes = el.querySelectorAll('.is-close');
    const preloader = el.querySelector('[data-loading]');
    const initialRect = {};
    const canvasRect = canvas.getBoundingClientRect();
    const tooltips = el.querySelectorAll('[data-tooltip]');

    // fake loading from 0 - 100%
    const easeOutQuad = (t) => {
      return t * (2 - t);
    };

    const updatePreloader = () => {
      let start = null;
      const duration = 3000;
      const endPercentage = 100;

      function step(timestamp) {
        if (!start) start = timestamp;
        const progress = timestamp - start;
        const percentage = Math.min(easeOutQuad(progress / duration) * endPercentage, endPercentage);
        if (preloader) {
          preloader.textContent = Math.floor(percentage);
        }

        if (progress < duration) {
          requestAnimationFrame(step);
        } else {
          if (preloader) {
            preloader.textContent = '100';
          }
          el.classList.add('is-preloader-done');

          setTimeout(() => {
            el.classList.add('is-intro-done');
          }, 4250)
        }
      }

      requestAnimationFrame(step);
    };
    updatePreloader();

    const openModal = (id) => {
      const target = el.querySelector(`[data-popup="modal-${id}"]`);
      el.classList.add(`has-modal-${id}`);
      target.classList.add('is-active');
      window.scroll({
        top: 0,
        left: 0,
        behavior: 'smooth',
      });
    };

    const closeModal = (target) => {
      target.classList.remove('is-active');
      el.classList.remove(`has-${target.dataset.popup}`);
      map.style.transform = `scale(1)`;
      svg.style.transform = `translate(0, 0)`;
      groups.forEach((group) => group.classList.remove('is-active'));
    };

    closeModalButton.addEventListener('click', () => el.querySelector('.is-active .is-close')?.click());
    closes.forEach((close) => close.addEventListener('click', (e) => closeModal(e.target.closest('[data-popup]'))));
    ctas.forEach((cta) => cta.addEventListener('click', () => openModal(cta.dataset.popup)));

    groups.forEach((group) => {
      initialRect[group.id] = group.getBoundingClientRect();

      group.addEventListener('click', () => {
        const groupCenterX = (window.innerWidth - canvasRect.width) / 2 - initialRect[group.id].left + initialRect[group.id].width / 2;
        const groupCenterY = initialRect[group.id].top + initialRect[group.id].height / 2;

        svg.style.transform = `translate(${groupCenterX + canvasRect.width / 2 - popupWidth / 2}px, ${svgRect.height / 2 - groupCenterY}px)`;
        map.style.transform = `scale(${scales[group.id]})`;
        group.classList.add('is-active');
        openModal(group.id);
      });

      group.addEventListener('mouseenter', () => group.classList.add('is-hover'));
      group.addEventListener('mouseleave', () => group.classList.remove('is-hover'));
    });

    tooltips.forEach((tooltip) => {
      if (!tooltip.dataset.building) {
        return;
      }
      const trigger = el.querySelector(`#${tooltip.dataset.building}`);

      if (!trigger) {
        return;
      }

      tippy(trigger, {
        allowHTML: true,
        touch: false,
        content: tooltip.innerHTML,
        appendTo: document.body,
        followCursor: true,
        plugins: [followCursor],
        placement: 'right',
        arrow: false,
        offset: [0, 50],
        theme: 'commercial-bay',
        delay: [250, 0],
        animation: 'fade',
      });
    });
  }
}

register('commercial-bay', CommercialBay);
